import React, { useState, useEffect } from "react";
import userInfo from "@/Components/user";
import { AppProvider, useAppContext } from "@/AppContext";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Space, message } from "antd";
import { getQueryString } from "@/config/func";
import { LoadingOutlined } from "@ant-design/icons";
import {
  updateProject,
  updateFlow,
  updateJob,
  // projectsAll,
} from "@/services/common";
import "./index.less";

interface BreadcrumbItem {
  id: number | null;
  name: string;
  type: "projectList" | "project" | "flow" | "job";
}

interface EditState {
  isEditing: boolean;
  type: "projectList" | "project" | "flow" | "job" | null;
  id: number | null;
  name: string;
}

const Component = (props: any) => {
  const { state, actions } = useAppContext();
  const {
    curTitle,
    curPage,
    curProject,
    curFlow,
    curJob,
    flowMode,
    refreshMenu,
  } = state;
  const {
    setCurTitle,
    setCurPage,
    setCurFlow,
    setCurProject,
    setRefreshMenu,
    setCurJob,
  } = actions;
  const curl: any = useLocation();

  const [projectList, setProjectList] = useState<any>([]);
  const navigate = useNavigate();

  // 面包屑编辑状态
  const [editState, setEditState] = useState<EditState>({
    isEditing: false,
    type: null,
    id: null,
    name: "",
  });

  const [subEditLoading, setSubEditLoading] = useState<boolean>(false);

  //普通用户只显示当前名称，不提供改名功能
  const isNormalUser = userInfo?.role === "user";


  const getBreadcrumbItems = (): BreadcrumbItem[] => {
    const items: BreadcrumbItem[] = [];

    if (curProject) {
      items.push({
        id: null,
        name: '项目',
        type: "projectList",
      });
    }

    // 第一级：项目
    if (curProject) {
      items.push({
        id: curProject.id,
        name: curProject.name,
        type: "project",
      });
    }

    // 第二级：流程
    if (curFlow) {
      items.push({
        id: curFlow.id,
        name: curFlow.name,
        type: "flow",
      });
    }

    // 第三级：任务
    if (curJob && getQueryString('j')) {
      items.push({
        id: curJob.id,
        name: curJob.name,
        type: "job",
      });
    }

    return items;
  };

  const handleBreadcrumbClick = (item: BreadcrumbItem) => {
    if (editState.isEditing) return;

    switch (item.type) {
      case "projectList":
        navigate(`/project/home/list`);
        // setCurProject(projectList.find((p) => p.id === item.id) || curProject);
        setCurFlow(undefined);
        setCurJob(undefined);
        break;
      case "project":
        navigate(`/project/home/view?k=${item.id}`);
        // setCurProject(projectList.find((p) => p.id === item.id) || curProject);
        setCurFlow(undefined);
        setCurJob(undefined);
        break;
      case "flow":
        // setCurFlow(
        //   (curProject?.flows || []).find((f) => f.id === item.id) || curFlow
        // );
        // setCurJob(undefined);
        const s: any = curl.search.split("&");
        navigate(`${curl.pathname}${s[0]}&${s[1]}`);
        window.location.reload();
        // navigate(`project/flow?k=${item.id}`);
        break;
      // case "job":
      //   setCurJob(
      //     (curFlow?.jobs || []).find((j) => j.id === item.id) || curJob
      //   );
      //   break;
      default:
        break;
    }
  };

  // const loadData = async () => {
  //   const projectRes = await projectsAll(
  //     { owner_id: userInfo.id },
  //     userInfo.access_token
  //   );
  //   if (projectRes.status === 200) {
  //     setProjectList(projectRes.data.data);

  //   } else {
  //     message.error("加载项目列表失败");
  //   }
  // };

  // useEffect(() => {
  //   loadData();
  // }, []);

  const startEditing = (item: BreadcrumbItem) => {
    setEditState({
      isEditing: true,
      type: item.type,
      id: item.id,
      name: item.name,
    });
  };

  const cancelEditing = () => {
    setEditState({
      isEditing: false,
      type: null,
      id: null,
      name: "",
    });
  };

  const updateBreadcrumbName = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditState({
      ...editState,
      name: e.target.value,
    });
  };

  const submitEdit = async () => {
    if (!editState.type || !editState.id) return;
    setSubEditLoading(true)
    try {
      let result;
      // 根据类型调用不同的更新接口
      switch (editState.type) {
        case "project":
          result = await updateProject(
            editState.id,
            { name: editState.name },
            userInfo.access_token
          );
          if (result.status === 200) {
            // 更新当前项目
            setCurProject({
              ...curProject,
              name: editState.name,
            });

            // 更新项目列表中的项目名称
            const updatedProjects = projectList.map((p: any) =>
              p.id === editState.id ? { ...p, name: editState.name } : p
            );
            setProjectList(updatedProjects);

            // 如果当前项目是最后一级，更新标题
            if (curFlow === undefined && curJob === undefined) {
              setCurTitle(editState.name);
              // setRefreshMenu(!refreshMenu);
            }
          }
          break;

        case "flow":
          if (!curProject) return;

          result = await updateFlow(
            curProject.id,
            editState.id,
            { name: editState.name },
            userInfo.access_token
          );
          if (result.status === 200) {
            // 更新当前流程
            setCurFlow({
              ...curFlow,
              name: editState.name,
            });

            // 更新项目列表中的流程名称
            const updatedProjects = projectList.map((p: any) =>
              p.id === curProject.id
                ? {
                  ...p,
                  flows: p.flows.map((f: any) =>
                    f.id === editState.id ? { ...f, name: editState.name } : f
                  ),
                }
                : p
            );
            setProjectList(updatedProjects);

            // 如果当前流程是最后一级，更新标题
            if (curJob === undefined) {
              setCurTitle(editState.name);
              // setRefreshMenu(!refreshMenu);
            }
          }
          break;

        case "job":
          if (!curProject || !curFlow) return;
          
          result = await updateJob(
            editState.id,
            { name: editState.name },
            userInfo.access_token
          );
          if (result.status === 200) {
            // 更新当前任务
            setCurJob({
              ...curJob,
              name: editState.name,
            });

            // 更新项目列表中的任务名称
            const updatedProjects = projectList.map((p: any) =>
              p.id === curProject.id
                ? {
                  ...p,
                  flows: p.flows.map((f: any) =>
                    f.id === curFlow.id
                      ? {
                        ...f,
                        jobs: f.jobs.map((j: any) =>
                          j.id === editState.id
                            ? { ...j, name: editState.name }
                            : j
                        ),
                      }
                      : f
                  ),
                }
                : p
            );
            setProjectList(updatedProjects);
            setCurTitle(editState.name);
            // setRefreshMenu(!refreshMenu);
          }
          
          break;
      }

      // if (result && result.status === 200) {
      //   message.success("名称更新成功");
      //   setRefreshMenu(!refreshMenu);
      // } else {
      //   message.error("名称更新失败");
      // }

      if (result && result.status === 200) {

        message.success("名称更新成功");
      //   setRefreshMenu(!refreshMenu);
      // } else {
      //   message.error("名称更新失败");
      }
      setSubEditLoading(false)
      // 重置编辑状态
      cancelEditing();
    } catch (error) {
      message.error("更新过程中发生错误");
      cancelEditing();
    }
  };

  // 键盘事件处理
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      submitEdit();
    } else if (e.key === "Escape") {
      cancelEditing();
    }
  };

  return (
    <>
      <div className="custom-breadcrumb">
        {getBreadcrumbItems().map((item, index, array) => {
          //普通用户只显示最后一级（任务/流程）名称，前面的层级不展示
          if (isNormalUser && index !== array.length - 1) return null;
          return (
          <React.Fragment key={item.id}>
            {/* 如果是最后一级且不在编辑状态，显示编辑按钮 */}
            {index === array.length - 1 && !editState.isEditing ? (
              <div className="flex items-center">
                <button
                  // onClick={() => handleBreadcrumbClick(item)}
                  className="current"
                >
                  <div className="t3">{item.name}</div>
                </button>
                {/* 普通用户无修改功能 */}
                {!isNormalUser && (
                  <Button
                    size="small"
                    style={{ marginLeft: "0.5rem", border: "none" }}
                    onClick={() => startEditing(item)}
                  >
                    <div className="icon edit off"></div>
                  </Button>
                )}
              </div>
            ) : (
              // 非最后一级或正在编辑状态
              <>
              {index !== array.length - 1 && <button
                  onClick={() => handleBreadcrumbClick(item)}
                  className={index === array.length - 1 ? "current" : ""}
                >
                  {item.name}
                </button>}
                
              </>
            )}

            {index < array.length - 1 && <span className="separator">/</span>}
          </React.Fragment>
          );
        })}
      </div>

      {/* 编辑模式 - 只在编辑最后一级时显示 */}
      {editState.isEditing && (
        <div className="flex">
          <input
            type="text"
            value={editState.name}
            onChange={updateBreadcrumbName}
            onKeyDown={handleKeyDown}
            className="nameInput2"
            autoFocus
          />
          <Button size="small" onClick={()=>!subEditLoading&&submitEdit()} type="primary">
            {subEditLoading?<LoadingOutlined/>:<div className="icon ok"></div>}
          </Button>
          <Button size="small" onClick={cancelEditing}>
            <div className="icon cancel off"></div>
          </Button>
        </div>
      )}
    </>
  );
};

export default Component;
